import { Breadcrumb, Layout, Image, Row, Col, Button, Avatar, Upload, Input, Tabs, Popover, Checkbox, Alert, Spin, Typography, Badge, Modal, Dropdown, FloatButton, Form, Tooltip, ConfigProvider } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation, useParams } from 'react-router-dom'
import { DownOutlined, FormOutlined, UserOutlined, InfoCircleOutlined, StarOutlined, CommentOutlined, SmallDashOutlined, ControlOutlined, CloseOutlined, MessageOutlined } from '@ant-design/icons';
import { ProTable } from '@ant-design/pro-components';
import label_language from './../language'
import { useContext } from 'react';
const { Search, TextArea } = Input;
// const server_ws = ''
// const server_ws = 'ws://localhost:7450'
// const server_ws = 'wss://www.orange-technic.com:7445'
const server_ws = 'wss://api-keytravel.orange-technic.com:7444'
const ChatRoom = () => {
    const ref = useRef(0);
    const [data, setData] = useState([]);
    const [emoji, setEmoji] = useState([
        '😀', '😁', '😂', '😃', '😄', '😅', '😆', '😇', '😈', '😉', '😊', '😋', '😌', '😍', '😎', '😏',
        '😐', '😑', '😒', '😓', '😔', '😕', '😖', '😗', '😘', '😙', '😚', '😛', '😜', '😝', '😞', '😟',
        '😠', '😡', '😢', '😣', '😤', '😥', '😦', '😧', '😨', '😩', '😪', '😫', '😬', '😭', '😮', '😯',
        '😰', '😱', '😲', '😳', '😴', '😵', '😶', '😷', '😸', '😹', '😺', '😻', '😼', '😽', '😾', '😿',
        '🙀', '🙁', '🙂', '🙃', '🙄', '🙅', '🙆', '🙇', '🙈', '🙉', '🙊', '🙋', '🙌', '🙍', '🙎', '🙏',
        '✔️', '✖️', '⭐️', '⭕️', '❤️', '❗️', '❓️', '✨️', '👌', '👍', '👎', '👏', '👆', '👇', '👈', '👉', '👊', '👋'
    ]);
    const [ws, setWs] = useState(undefined)
    const [chatIDs, set_chatIDs] = useState([]);
    const [chatID, set_chatID] = useState(-1);
    const [new_chatID, set_new_chatID] = useState(null);
    const [chatrooms, set_chatrooms] = useState([]);
    const [todayDate] = useState(Date.now())
    const block_of_chat = useRef()
    const ref_message = useRef()
    const botton_of_chat = useRef()
    const [cur_page, set_cur_page] = useState(1);
    const [total, set_total] = useState(0);
    const [unread_count, set_unread_count] = useState(0);
    const [abort_content, set_abort_content] = useState(new AbortController());
    const [spinning, set_spinning] = useState(false);
    const [chatName, set_chatName] = useState('');
    const [message, set_message] = useState('');
    const [search_chatName, set_search_chatName] = useState('');
    const [content, set_content] = useState([]);
    useEffect(() => {
        axios.get('/chat/init/' + todayDate)
            .then(response => {
                if (response.data.status == 'success') {
                    Object.entries(response.data).forEach(([key, value]) => {
                        if (key == 'class') {
                            // changeClass('init', value);
                        } else if (key == 'chatroom') {
                            set_chatrooms(value.filter(filter_item => filter_item.UID !== '-1'));
                            let chatIDs = new Object();
                            value.forEach((data, i) => {
                                chatIDs[i] = data.chatID;
                            })
                            chatIDs = JSON.stringify(chatIDs);
                            // console.log(chatIDs);
                            set_chatIDs(chatIDs);
                            // changeChatroom('init', value);
                        } else if (key == 'notification') {
                            // changeNotification('init', response.notification);
                        } else if (key == 'star') {
                            // changeStar('init', response.star);
                        }
                    });
                    setWs(new WebSocket(server_ws))
                }
            })

        return () => {
            ws.close()
        }
    }, [])

    const initWebSocket = () => {
        //對 getMessage 設定監聽，如果 server 有透過 getMessage 傳送訊息，將會在此被捕捉
        ws.onopen = function (e) {
            console.log("Connection established!");
            ws.send(chatIDs);
        };
        ws.onmessage = function (e) {
            let response = JSON.parse(e.data);
            Object.entries(response).forEach(([key, value]) => {
                if (key == "type") {
                    if (value == "chat") {
                        set_new_chatID(response?.data?.message)
                    }
                }
            })
            // $.each(response,function(key,value){
            // if(key=="type"){
            // if(value=="chat")
            // routine();
            // }
            // })
        };
    }
    const get_new_chatroom = (_chatID) => {
        axios
            .get('/chat/chatroom_new', {
                params: {
                    chatID: _chatID
                }
            })
            .then(response => {
                set_chatrooms(prev => prev.reduce((map_all, map_item) => {
                    if (map_item.chatID == _chatID) {
                        return [response.data.find(_ => true), ...map_all]
                    } else {
                        return [...map_all, map_item]
                    }
                }, []))
            })
    }
    useEffect(() => {
        if (new_chatID != null) {
            get_new_content(new_chatID)
            get_new_chatroom(new_chatID)
            set_new_chatID(null)
        }
    }, [new_chatID])
    useEffect(() => {
        if (ws) {
            //連線成功在 console 中打印訊息
            console.log('success connect!')
            //設定監聽
            initWebSocket()
        }
    }, [ws])
    const getTarget = (_chatID, _chatName) => {
        set_chatID(_chatID)
        // // console.log($(div).attr("data-name"));
        // // chatID=$(div).attr("data-name");
        // scrollable = false;
        // last['count'] = 0;
        // $('[name=chatBox]').html("");
        let params = {

        };
        if (chatID != _chatID) {
            get_content(
                {
                    chatID: _chatID,
                }
            )
        }

        // chatName = decodeURIComponent(_chatName);
        // $('[name=navbarChatroomTitle]').text(chatName);
        // $('#tool_dropdown').show();
        // // resetLimit();
        // if (chatID != _chatID) {
        //     chatID = _chatID;
        //     routine();
        // } else {
        //     scrollToTag();
        // }
        // updateLastReadTime();
        // $('.msg_history').scrollTop(document.body.scrollHeight);

        /*  */
        // schedule();
        // getReadcount();

        // routine();
    }
    const get_content = (data) => {
        set_spinning(true)
        abort_content.abort()
        const abort_content_ = new AbortController();
        set_abort_content(abort_content_)
        axios
            .get('/chat/content',
                {
                    params: data,
                    signal: abort_content_.signal
                }
            )
            .then(response => {
                if (data.before)
                    set_content(prev => (response.data.data).concat(prev))
                else if (data.total) {
                    set_content(prev => prev.concat(response.data.data))
                    scroll_to_bottom()
                }
                else {
                    set_content(response.data.data)
                    scroll_to_bottom()
                }
                set_cur_page(response.data.cur_page == 0 ? 1 : response.data.cur_page)
                set_total(response.data.total)
            })
            .finally(() => {
                set_spinning(false)
            })
    }
    const get_new_content = (_chatID) => {
        get_content(
            {
                chatID: chatID,
                cur_page: cur_page,
                total: total
            }
        )
    }
    const get_more_content = () => {
        get_content(
            {
                chatID: chatID,
                cur_page: cur_page - 1,
                before: true
            }
        )
    }
    const scroll_to_bottom = () => {
        block_of_chat.current.scrollTo({
            top: botton_of_chat.current.offsetTop
        });
    }
    const post_chatroom = (users) => {
        axios
            .post('/chat/chatroom', {
                data: JSON.stringify({
                    title: users.find(_ => true)?.name,
                    member: [
                        {

                            UID: users.find(_ => true)?.user_id
                        }
                    ]
                })
            })
            .then(response => {
                set_chatrooms(prev => [{
                    chatID: response.data?.chatID,
                    chatName: users.find(_ => true)?.name
                }, ...prev]);
                let chatIDs = new Object();
                chatrooms.forEach((data, i) => {
                    chatIDs[i] = data.chatID;
                })
                chatIDs[chatrooms.length] = response.data?.chatID
                chatIDs = JSON.stringify(chatIDs);
                ws.send(chatIDs);
            })
    }
    const empty_chat = () => {
        set_chatID(-1)
        set_cur_page(1)
        set_chatName('')
        set_content([])
    }
    const delete_chatroom = () => {
        set_chatrooms(prev => [...prev.filter(filter_item => filter_item.chatID !== chatID)]);
        empty_chat()
        axios
            .delete('/chat/chatroom', {
                data: {
                    data: JSON.stringify({ chatID: chatID })
                },
            })
    }
    return (<>
        {/* <Popover placement="bottomRight"
            content={(<> */}
        <Row gutter={8}>
            <Col span={24} style={{ backgroundColor: '#48a1e3' }}>
                <Row gutter={8} justify={'center'} align={'middle'} style={{ padding: '10px' }}>
                    <Col style={{ color: '#FFFFFF', fontSize: '16px' }}>接收新訊息通知</Col>
                    <Col>
                        <Button style={{ background: '#5485ae', color: '#FFFFFF', border: 'none' }} shape='round'>開啟桌面通知</Button>
                    </Col>
                </Row>
            </Col>
            <Col span={24} style={{ borderBottom: 'solid #f5f5f5 3px', borderLeft: 'solid #f5f5f5 3px', borderRight: 'solid #f5f5f5 3px' }}>
                <Row gutter={8} justify={'space-between'} align={'middle'} style={{ padding: '10px' }}>
                    <Col style={{ fontSize: '16px' }}>收件區</Col>
                    <Col>
                        <Row gutter={8}>
                            <Col>
                                <Dropdown
                                    menu={{
                                        items: [
                                            {
                                                key: 'leave',
                                                label: '離開聊天室'
                                            },
                                        ],
                                        onClick: () => {
                                            delete_chatroom();
                                        }
                                    }
                                    }
                                >

                                    <Button style={{ color: '#48a1e3', borderColor: '#48a1e3' }} shape='round'>設定
                                        <DownOutlined />
                                    </Button>
                                </Dropdown>
                            </Col>
                            <Col>
                                <Button_new_chatroom handle_submit={users => post_chatroom(users)} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col span={6} style={{ borderBottom: 'solid #f5f5f5 3px', borderLeft: 'solid #f5f5f5 3px', borderRight: 'solid #f5f5f5 1px', minHeight: '600px', maxHeight: '600px', overflowY: 'auto' }}>
                <Col span={24} style={{ padding: '10px', borderBottom: 'solid #f5f5f5 3px', minHeight: '55px', maxHeight: '55px' }}>
                    <Search
                        placeholder="所有對話"
                        onSearch={e => set_search_chatName(e)}
                        allowClear
                        style={{
                            width: '100%',
                        }}
                    />
                </Col>
                {chatrooms.filter(filter_item => (filter_item?.chatName || '').includes(search_chatName)).map(map_item => (<>
                    <Col span={24} style={{ padding: '10px', borderBottom: 'solid #f5f5f5 3px' }} key={map_item.chatID}
                        onClick={() => {
                            getTarget(map_item.chatID, map_item.chatName)
                            set_chatName(map_item.chatName)
                        }}
                    >
                        <Row>
                            <Col span={6}>
                                <Avatar size={40} icon={<UserOutlined />} />
                            </Col>
                            <Col span={18}>
                                <Row justify={'space-between'}>
                                    <Col xs={24} lg={16} xl={18}
                                        style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}><sapn style={{ fontWeight: 'bold', overflow: 'truncate' }}>{map_item.chatName}</sapn></Col>
                                    <Col xs={24} lg={8} xl={6}><span style={{ color: '#00000040' }}>{map_item.LastTime}</span></Col>
                                </Row>
                                <Row>
                                    <Col
                                        style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        <span style={{ color: '#00000060' }} >{map_item.content}</span></Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </>))
                }
            </Col >
            <Col span={18} style={{ borderBottom: 'solid #f5f5f5 3px', borderLeft: 'solid #f5f5f5 1px', borderRight: 'solid #f5f5f5 3px', minHeight: '600px', maxHeight: '600px', overflowY: 'auto', position: 'relative' }}>
                <Col span={24} style={{ padding: '10px', borderBottom: 'solid #f5f5f5 3px', minHeight: '55px', maxHeight: '55px' }}>
                    <Row gutter={8} align={'middle'} justify={'space-between'}>
                        <Col >
                            <Row gutter={8} align={'middle'}>
                                <Col>
                                    <Avatar size={40} icon={<UserOutlined />} />
                                </Col>
                                <Col><sapn style={{ fontSize: '15px' }}>{chatName}</sapn></Col>
                            </Row>
                        </Col>
                        <Col >
                            <Row gutter={16} justify={'space-around'}>
                                <Col>
                                    <InfoCircleOutlined style={{ color: '#5485ae', }} />
                                </Col>
                                <Col >
                                    <StarOutlined style={{ color: '#5485ae', }} />
                                </Col>
                                <Col >
                                    <span style={{ color: '#5485ae', }} ></span>
                                </Col>
                                <Col >
                                    <span style={{ color: '#5485ae', }} >封存</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Spin spinning={spinning}>
                    <Col ref={block_of_chat} span={24} style={{ height: '60vh', overflowY: 'scroll', overflowX: 'hidden', overscrollBehavior: 'contain' }}>
                        {cur_page != 1 && (<>
                            <Row justify={'center'}>
                                <Button type={'text'}
                                    onClick={() => {
                                        get_more_content()
                                    }}
                                >載入更多訊息</Button>
                            </Row>
                        </>)}
                        <Row justify={'center'} align={'bottom'} gutter={[24, 24]} >
                            {/* <Col style={{ padding: '5px', overflow: 'scroll' }}>
                                <span style={{ color: '#00000060' }}> Yesterday at 4:45 PM</span>
                            </Col> */}
                            {content.map(map_item => (<>
                                <Col span={24} key={map_item.row_num}>
                                    <Row justify={map_item.diff === 'me' ? 'end' : 'start'}>
                                        <Col>
                                            <Typography.Text type="secondary">
                                                {map_item.sentTime}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                    <Row justify={map_item.diff === 'me' ? 'end' : 'start'}>
                                        <Col>
                                            <Alert message={<div dangerouslySetInnerHTML={{ __html: map_item.content }}></div>} type={map_item.diff === 'me' ? "info" : "success"} />
                                        </Col>
                                    </Row>
                                </Col>
                            </>))}
                        </Row>
                        <Typography.Text ref={botton_of_chat} />
                    </Col >
                    <Col span={24}>
                        <Row gutter={16} align={'middle'}>
                            <Col flex={'auto'}>
                                <Input.TextArea rows={2} placeholder={'輸入您的訊息......'}
                                    value={message}
                                    onChange={e => set_message(e.target.value)}
                                    onKeyPress={e => {
                                        if (e.code === 'Enter' && !e.shiftKey) {
                                            ref_message.current.click()
                                            e.preventDefault()
                                            return false;
                                        }
                                    }}
                                ></Input.TextArea>
                                {/* <Input placeholder={'輸入您的訊息......'} /> */}
                            </Col>
                            <Col style={{ cursor: 'pointer' }} >
                                <Popover
                                    placement="top"
                                    content={(
                                        <>
                                            <div style={{ width: '180px', overflow: 'scroll', height: '250px' }}>
                                                <Row gutter={[8, 8]} justify='center'>
                                                    {emoji.map((value, index) => {
                                                        return (
                                                            <Col span={4} style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    set_message(prev => prev + value)
                                                                }}
                                                            >
                                                                {value}
                                                            </Col>
                                                        )
                                                    })}
                                                </Row>
                                            </div>
                                        </>)}
                                    title={false}
                                    trigger="click"
                                >
                                    <svg viewBox="64 64 896 896" fill="#00000060" focusable="false" data-icon="smile" width="1.5em" height="1.5em" aria-hidden="true"><path d="M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4z"></path></svg>
                                </Popover>
                            </Col>
                            <Col style={{ cursor: 'pointer' }} onClick={(e) => ref.current.click()}>
                                <svg viewBox="64 64 896 896" focusable="false" data-icon="link" width="1.5em" height="1.5em" fill="#00000060" aria-hidden="true"><path d="M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z"></path></svg>
                                <input type="file" id="my_file" hidden ref={ref} />
                            </Col>
                            <Col>
                                <Button style={{ color: '#48a1e3', }}
                                    ref={ref_message}
                                    onClick={() => {
                                        let message_ = message;
                                        message_ = decodeURIComponent(message_).replace(/\r?\n/g, '<br />');
                                        set_message('')
                                        axios
                                            .patch('/chat/message', {
                                                Msg: decodeURIComponent(message_),
                                                chatID: chatID,
                                            })
                                            .finally(() => {
                                                scroll_to_bottom();
                                            })
                                    }}
                                >送出訊息</Button>
                            </Col>
                        </Row>
                    </Col>
                </Spin>
            </Col >
        </Row >

        {/* </>)} trigger="click" */}
        {/* >
        <Badge count={unread_count} style={{ zIndex: '99' }}>
            <Avatar icon={<CommentOutlined />} />
        </Badge>
    </Popover> */}
    </>)
}
export default ChatRoom;
const Button_new_chatroom = (props) => {
    const [open, set_open] = useState(false);
    const [data, set_data] = useState([]);
    const [selections, set_selections] = useState([]);
    const [total, set_total] = useState(0)
    const [check, setCheck] = useState([])
    const ChangeColumnsCheckbox = ({ columns, check, setCheck }) => {
        const onChange = (list) => {
            setCheck(list);
        }
        return (<Checkbox.Group
            style={{
                width: '100%',
            }}
            value={check}
            onChange={onChange}
        >
            <Row>
                {
                    columns.map((map_item, index) => {
                        return <Col span={12}>
                            <Checkbox value={map_item.key}>{map_item.title}</Checkbox>
                        </Col>
                    })
                }
            </Row>
        </Checkbox.Group>)
    }
    const columns = [
        {
            title: '姓名',
            key: 'name',
            dataIndex: 'name',
            hideInSearch: true,
        },
        {
            title: '職位',
            key: 'position',
            dataIndex: 'position',
            hideInSearch: true,
        }
    ]
    const handle_submit = () => {
        set_open(false)
        props.handle_submit(selections)
    }
    return (<>
        <Button style={{ color: '#48a1e3', borderColor: '#48a1e3' }} shape='round'
            onClick={() => set_open(true)}
        >撰寫
            <FormOutlined />
        </Button>
        <Modal
            zIndex={9999}
            bodyStyle={{
                maxHeight: '60vh',
                overflowY: 'scroll'
            }}
            open={open}
            onOk={() => handle_submit()}
            onCancel={() => set_open(false)}
            closable
        >
            <ProTable
                headerTitle={<></>}
                rowSelection={{
                    type: 'radio',
                    onChange: (_, rows) => set_selections(rows)
                }}
                request={async (params = {}, sort, filter) => {
                    console.log(params, sort, filter, check)
                    return axios
                        .get('/cramSchool/api/chatroom', {
                            params: {
                                cur_page: params?.current,
                                size: params?.pageSize,
                            }
                        })
                        .then(response => {
                            return response.data
                        })
                }}
                columns={columns}
                rowKey={'name'}
                pagination={{
                    pageSize: 5,
                }}
                search={false}
                options={{
                    search: {
                        suffix: (<>
                            <Popover
                                overlayStyle={{
                                    width: "40vw"
                                }}
                                placement="topLeft"
                                title={"選擇欲搜尋欄位"}
                                content={<ChangeColumnsCheckbox columns={columns} check={check} setCheck={setCheck} />}
                            >
                                <ControlOutlined />
                            </Popover>
                        </>),
                    }
                }}
            />
        </Modal>
    </>)
}

const Mini_chatRoom = (props) => {
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const ref_message = useRef()
    const [form] = Form.useForm();
    const [message, set_message] = useState('');
    const [chatName, set_chatName] = useState(null);
    const [spinning, set_spinning] = useState(false);
    const [content, set_content] = useState([]);
    const [abort_content, set_abort_content] = useState(new AbortController());
    const [new_chatID, set_new_chatID] = useState(null);
    const [chatID, set_chatID] = useState(-1);
    const [ws, setWs] = useState(undefined)
    const [open, setOpen] = useState(false);
    const [modal_open, set_modal_open] = useState(false);
    const [cur_page, set_cur_page] = useState(1);
    const [total, set_total] = useState(0);
    const botton_of_chat = useRef()
    const block_of_chat = useRef()
    const ref = useRef(0);
    const [emoji, setEmoji] = useState([
        '😀', '😁', '😂', '😃', '😄', '😅', '😆', '😇', '😈', '😉', '😊', '😋', '😌', '😍', '😎', '😏',
        '😐', '😑', '😒', '😓', '😔', '😕', '😖', '😗', '😘', '😙', '😚', '😛', '😜', '😝', '😞', '😟',
        '😠', '😡', '😢', '😣', '😤', '😥', '😦', '😧', '😨', '😩', '😪', '😫', '😬', '😭', '😮', '😯',
        '😰', '😱', '😲', '😳', '😴', '😵', '😶', '😷', '😸', '😹', '😺', '😻', '😼', '😽', '😾', '😿',
        '🙀', '🙁', '🙂', '🙃', '🙄', '🙅', '🙆', '🙇', '🙈', '🙉', '🙊', '🙋', '🙌', '🙍', '🙎', '🙏',
        '✔️', '✖️', '⭐️', '⭕️', '❤️', '❗️', '❓️', '✨️', '👌', '👍', '👎', '👏', '👆', '👇', '👈', '👉', '👊', '👋'
    ]);

    useEffect(() => {
        // setWs(new WebSocket(server_ws))
        // return () => {
        //     ws.close()
        // }
    }, [])
    const initWebSocket = () => {
        //對 getMessage 設定監聽，如果 server 有透過 getMessage 傳送訊息，將會在此被捕捉
        ws.onopen = function (e) {
            console.log("Connection established!");
        };
        ws.onmessage = function (e) {
            let response = JSON.parse(e.data);
            Object.entries(response).forEach(([key, value]) => {
                if (key == "type") {
                    if (value == "chat") {
                        set_new_chatID(response?.data?.message)
                    }
                }
            })
            // $.each(response,function(key,value){
            // if(key=="type"){
            // if(value=="chat")
            // routine();
            // }
            // })
        };
    }
    useEffect(() => {
        if (ws) {
            //連線成功在 console 中打印訊息
            console.log('success connect!')
            //設定監聽
            initWebSocket()
        }
    }, [ws])
    const get_new_content = (_chatID) => {
        get_content(
            {
                chatID: chatID,
                cur_page: cur_page,
                total: total
            }
        )
    }
    useEffect(() => {
        if (new_chatID != null) {
            get_new_content(new_chatID)
            set_new_chatID(null)
        }
    }, [new_chatID])
    const get_content = (data) => {
        set_spinning(true)
        abort_content.abort()
        const abort_content_ = new AbortController();
        set_abort_content(abort_content_)
        axios
            .get('/chat/content/public',
                {
                    params: data,
                    signal: abort_content_.signal
                }
            )
            .then(response => {
                if (data.before)
                    set_content(prev => (response.data.data).concat(prev))
                else if (data.total) {
                    set_content(prev => prev.concat(response.data.data))
                    scroll_to_bottom()
                }
                else {
                    set_content(response.data.data)
                    scroll_to_bottom()
                }
                set_cur_page(response.data.cur_page == 0 ? 1 : response.data.cur_page)
                set_total(response.data.total)
            })
            .finally(() => {
                set_spinning(false)
            })
    }
    const scroll_to_bottom = () => {
        block_of_chat.current.scrollTo({
            top: botton_of_chat.current.offsetTop
        });
    }
    useEffect(() => {
        if (open && chatName == null) {
            set_modal_open(true);
        }
    }, [open])
    const post_chatroom = (values) => {
        set_spinning(true)
        set_modal_open(false);
        set_chatName(values.name)
        axios
            .post('/cramSchool/api/chatroom', {
                data: {
                    title: values.name,
                }
            })
            .then(response => {
                let chatIDs = new Object();
                chatIDs = { [0]: response.data?.chatID };
                chatIDs = JSON.stringify(chatIDs);
                set_chatID(response.data?.chatID)
                ws.send(chatIDs);
            })
            .finally(() => {
                set_spinning(false)

            })
    }
    return (<>
        <Modal
            open={modal_open}
            title={'該如何稱呼您'}
            onOk={() => {
                form
                    .validateFields()
                    .then(values => {
                        post_chatroom(values)
                    })

            }}
            onCancel={() => {
                set_modal_open(false);
                setOpen(false)
            }}
        >
            <Form
                form={form}
            >
                <Form.Item
                    name={'name'}
                    rules={[{ required: true, message: '請輸入名稱' }]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
        <Popover
            content={(
                <>
                    <div style={{ width: '300px', padding: '0px' }}>
                        <Row gutter={8}>
                            <Col span={24} style={{ backgroundColor: '#48a1e3', position: 'relative', height: '60px', padding: '10px' }}>
                                <Row>
                                    <Col span={24} style={{ color: '#FFFFFF', fontSize: '14px' }}>{props.name ?? "Mercy"}</Col>
                                    <Col span={24} style={{ color: '#FFFFFF', fontSize: '13px' }}>我們會盡快回覆</Col>
                                    <Col style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '10px' }} onClick={e => setOpen(false)}>
                                        <CloseOutlined style={{ color: '#FFFFFF' }} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Spin spinning={spinning}>
                                <Col ref={block_of_chat} flex={'auto'} style={{ width: '300px', height: '300px', overflowY: 'scroll', overflowX: 'hidden', overscrollBehavior: 'contain' }}>
                                    <Row>
                                        {content.map(map_item => (<>
                                            <Col span={24} key={map_item.row_num}>
                                                <Row justify={map_item.diff === 'me' ? 'end' : 'start'}>
                                                    <Col>
                                                        <Typography.Text type="secondary">
                                                            {map_item.sentTime}
                                                        </Typography.Text>
                                                    </Col>
                                                </Row>
                                                <Row justify={map_item.diff === 'me' ? 'end' : 'start'}>
                                                    <Col>
                                                        <Alert message={<div dangerouslySetInnerHTML={{ __html: map_item.content }}></div>} type={map_item.diff === 'me' ? "info" : "success"} />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </>))}
                                    </Row>
                                    <Typography.Text ref={botton_of_chat} />
                                </Col>
                            </Spin>
                        </Row>
                        <Row gutter={8} style={{ paddingTop: '5px' }} justify={'center'} align={'bottom'}>
                            <Col span={20}>
                                <Input.TextArea rows={2} placeholder={'輸入您的訊息......'}
                                    value={message}
                                    onChange={e => set_message(e.target.value)}
                                    onKeyPress={e => {
                                        if (e.code === 'Enter' && !e.shiftKey) {
                                            ref_message.current.click()
                                            e.preventDefault()
                                            return false;
                                        }
                                    }}
                                ></Input.TextArea>
                                {/* <Input placeholder={'輸入您的訊息......'} /> */}
                            </Col>
                            <Col style={{ cursor: 'pointer' }} span={2} >
                                <Popover
                                    placement="top"
                                    content={(
                                        <>
                                            <div style={{ width: '180px', overflow: 'scroll', height: '120px' }}>
                                                <Row gutter={[8, 8]} justify='center'>
                                                    {emoji.map((value, index) => {
                                                        return (
                                                            <Col span={4} style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    set_message(prev => prev + value)
                                                                }}
                                                            >
                                                                {value}
                                                            </Col>
                                                        )
                                                    })}
                                                </Row>
                                            </div>
                                        </>)}
                                    title={false}
                                    trigger="click"
                                >
                                    <svg viewBox="64 64 896 896" fill="#dfe0e3" focusable="false" data-icon="smile" width="1.5em" height="1.5em" aria-hidden="true"><path d="M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4z"></path></svg>
                                </Popover>
                            </Col>
                            <Col style={{ cursor: 'pointer' }} span={2} onClick={(e) => ref.current.click()}>
                                <svg viewBox="64 64 896 896" focusable="false" data-icon="link" width="1.5em" height="1.5em" fill="#dfe0e3" aria-hidden="true"><path d="M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z"></path></svg>
                                <input type="file" id="my_file" hidden ref={ref} />
                            </Col>
                            <Button style={{ color: '#48a1e3', }}
                                ref={ref_message}
                                onClick={() => {
                                    let message_ = message;
                                    message_ = decodeURIComponent(message_).replace(/\r?\n/g, '<br />');
                                    set_message('')
                                    axios
                                        .patch('/chat/message/public', {
                                            Msg: decodeURIComponent(message_),
                                            chatID: chatID,
                                        })
                                        .finally(() => {
                                            scroll_to_bottom();
                                        })
                                }}
                            >送出訊息</Button>
                        </Row>
                    </div>
                </>
            )}
            title={false}
            trigger="click"
            open={open}
        // onOpenChange={handleOpenChange}
        >
            <Tooltip
                defaultOpen
                // title={label_language.utility.children.layout.children.start_chat[language]}
                title={'開始聊天'}
                placement={'leftTop'}
                trigger={['contextMenu','hover']}
            >
                <FloatButton
                    shape="square"
                    type='primary'
                    style={{
                        right: 24,
                        // width: '200px',
                        // padding: '5px',
                        // backgroundColor: '#00a4e9'
                    }}
                    onClick={e => setOpen(true)}
                    // description={<span style={{ fontSize: '20px' }} onClick={e => setOpen(true)}>立即展開交流！</span>}
                    icon={<MessageOutlined />}
                />
            </Tooltip>
        </Popover>
    </>)
}
export { Mini_chatRoom };